import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import BingoGame from "./components/BingoGame";
import HowToPlayPage from "./pages/HowToPlayPage";
import GenerateCardsPage from "./pages/GenerateCardsPage";
import BingoPatternsPage from "./pages/BingoPatternsPage"; // Import the new page
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HowToPlayModal from "./components/HowToPlayModal";
import GenerateCardsModal from "./components/GenerateCardsModal";

function App() {
  const [showHowToPlayModal, setShowHowToPlayModal] = useState(false);
  const [showGenerateCardsModal, setShowGenerateCardsModal] = useState(false);
  const location = useLocation();

  const openHowToPlay = () => {
    setShowHowToPlayModal(true);
  };

  const closeHowToPlay = () => {
    setShowHowToPlayModal(false);
  };

  const openGenerateCards = () => {
    setShowGenerateCardsModal(true);
  };

  const closeGenerateCards = () => {
    setShowGenerateCardsModal(false);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar
        openHowToPlay={openHowToPlay}
        openGenerateCards={openGenerateCards}
        currentPath={location.pathname}
      />

      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<BingoGame />} />
          <Route path="/how-to-play-bingo" element={<HowToPlayPage />} />
          <Route
            path="/bingo-cards-generator"
            element={<GenerateCardsPage />}
          />
          <Route path="/bingo-patterns" element={<BingoPatternsPage />} />{" "}
          {/* Add new route */}
        </Routes>
      </main>

      <Footer
        openHowToPlay={openHowToPlay}
        openGenerateCards={openGenerateCards}
      />

      {/* Modals */}
      <HowToPlayModal isOpen={showHowToPlayModal} onClose={closeHowToPlay} />
      <GenerateCardsModal
        isOpen={showGenerateCardsModal}
        onClose={closeGenerateCards}
      />
    </div>
  );
}

export default App;
